import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ShelfCard = ({ shelf, testId, className = "" }) => (
  <Link
    to={`/shelf/${shelf.slug}`}
    data-testid={testId}
    className={`cozy-card group block rounded-3xl overflow-hidden h-full ${className}`}
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <img
        src={shelf.img}
        alt={shelf.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 book-spine pointer-events-none" />
      <span
        className="absolute top-4 left-4 px-3 py-1 rounded-full text-[11px] font-semibold tracking-wider uppercase"
        style={{
          background: "var(--surface)",
          color: "var(--brand)",
          border: "1px solid var(--border)",
        }}
      >
        {shelf.tag}
      </span>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <h3
        className="font-serif text-2xl font-medium mb-1"
        style={{ color: "var(--text)" }}
      >
        {shelf.title}
      </h3>
      <p
        className="text-sm italic font-serif"
        style={{ color: "var(--text-muted)" }}
      >
        By {shelf.author}
      </p>
      <p className="mt-3 text-sm flex-1" style={{ color: "var(--text-soft)" }}>
        {shelf.desc}
      </p>
      {shelf.longDesc && (
        <p
          className="mt-3 text-sm leading-relaxed hidden lg:block"
          style={{ color: "var(--text-muted)" }}
        >
          {shelf.longDesc}
        </p>
      )}
      {shelf.moods && (
        <div className="mt-4 flex flex-wrap gap-2">
          {shelf.moods.map((mood) => (
            <span
              key={mood}
              className="text-[10px] px-2.5 py-1 rounded-full uppercase tracking-wider font-medium"
              style={{
                background: "var(--bg-alt)",
                color: "var(--text-muted)",
              }}
            >
              {mood}
            </span>
          ))}
        </div>
      )}
      <div
        className="mt-5 flex items-center justify-between pt-5 border-t"
        style={{ borderColor: "var(--border-soft)" }}
      >
        <span className="text-xs font-medium" style={{ color: "var(--text-muted)" }}>
          {shelf.bookCount ? `${shelf.bookCount} · Open shelf` : "Open shelf"}
        </span>
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center transition-colors group-hover:bg-[var(--brand-tint)]"
          style={{ background: "var(--bg-alt)", color: "var(--brand)" }}
        >
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
    </div>
  </Link>
);

export default ShelfCard;
